import clsx from "clsx";
import styles from "./Pagination.module.scss";

interface PaginationProps {
  currentPage: number;
  range: (number | "dots")[];
  onChange: (page: number) => void;
}

const Pagination = ({ currentPage, range, onChange }: PaginationProps) => {
  return (
    <div className={styles.pagination}>
      {range.map((page, index) =>
        page === "dots" ? (
          <span key={index} className="dots">
            ...
          </span>
        ) : (
          <button
            key={index}
            className={clsx(styles.page, {
              [styles.active]: currentPage === page,
            })}
            onClick={() => onChange(page)}
            type="button"
          >
            {page}
          </button>
        ),
      )}
    </div>
  );
};

export default Pagination;
